<template>
    <div class="detail" v-loading="loading">
        <div class="detail-first">
            <div class="detail-first-block">
                <div class="first-block-list" v-for="(item, index) in 5" :key="index">
                    <div class="first-block-list-title">
                        {{
                            index == 0
                            ? '用户id'
                            : index == 1
                                ? '用户名称'
                                : index == 2
                                    ? '用户电话'
                                    : index == 3
                                        ? '打款状态'
                                        : index == 4
                                            ? '兑换时间'
                                            : ''
                        }}
                    </div>
                    <div class="first-block-list-input" v-if="index != 4">
                        <el-input v-if="index == 0" placeholder="请输入用户id" v-model="userId" clearable>
                        </el-input>

                        <el-input v-if="index == 1" placeholder="请输入用户名称" v-model="userName" clearable>
                        </el-input>

                        <el-input v-if="index == 2" placeholder="请输入用户电话" v-model="userPhone" clearable>
                        </el-input>

                        <el-select v-if="index == 3" v-model="remitType" clearable placeholder="请选择">
                            <el-option v-for="item in remitList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="first-block-list-picker" v-else>
                        <el-date-picker v-model="conversionTime" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="detail-first-button">
                <div class="detail-first-button-left" @click="detailInquire">查询</div>
                <div class="detail-first-button-right" @click="detailReset">重置</div>
            </div>
        </div>

        <div class="detail-second">
            <div class="detail-second-top">
                <div class="second-top-left">查询结果</div>
                <div class="second-top-right">
                    <div class="second-top-right-refresh" @click="refresh">刷新</div>
                    <div class="second-top-right-derive" @click="export2Excel">
                        <img class="derive-img" src="../../assets/common/common-derive.png" />
                        <div class="derive-title">导出明细</div>
                    </div>
                </div>
            </div>

            <div class="detail-second-table">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%; cursor: pointer"
                    border="" @selection-change="handleSelectionChange" :header-cell-style="{
                        color: '#333333',
                        backgroundColor: '#FAFAFA',
                    }">
                    <!-- 自定义暂无数据 -->
                    <template slot="empty">
                        <div class="empty-block">
                            <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                            <div class="empty-block-text">暂无数据～</div>
                        </div>
                    </template>
                    <el-table-column type="selection" width="45"></el-table-column>
                    <el-table-column prop="userId" label="用户ID"> </el-table-column>
                    <el-table-column prop="userPhone" label="用户手机号" width="196">
                    </el-table-column>
                    <el-table-column prop="nickname" label="用户昵称" width="220">
                    </el-table-column>
                    <el-table-column prop="redName" label="红包名称"></el-table-column>
                    <el-table-column label="兑奖金额(元)" width="122">
                        <template slot-scope="scope">
                            <span>¥ &nbsp; {{ scope.row.redNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="兑换时间">
                    </el-table-column>
                    <el-table-column label="兑换状态" width="124">
                        <template slot-scope="scope">
                            <div :style="{
                                color:
                                    scope.row.status == 'ENTER'
                                        ? '#36C100'
                                        : scope.row.status == 'WAIT'
                                            ? '#999999'
                                            : '#ED6D1F',
                            }">
                                {{
                                    scope.row.status == 'ENTER'
                                    ? '打款成功'
                                    : scope.row.status == 'WAIT'
                                        ? '打款中'
                                        : '打款失败'
                                }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="detail-second-Pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes" :total="totalNum">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getredDetails } from '../../api/activities'
export default {
    data() {
        return {
            /* 第一区域 */
            // 用户id
            userId: '',
            // 用户名称
            userName: '',
            // 用户电话
            userPhone: '',
            // 打款类型
            remitType: '',
            remitList: [
                {
                    value: 0,
                    label: '全部',
                },
                {
                    value: 1,
                    label: '打款成功',
                },
                {
                    value: 2,
                    label: '打款失败',
                },
            ],
            // 兑换时间区间
            conversionTime: [],
            // 用户时间输入框的时候起始值
            conversionTimeA: '',
            // 用户时间输入框的时候结尾值
            conversionTimeB: '',

            /* end */

            // 表格区域
            tableData: [],
            // 表格列表总数
            totalNum: 0,
            // 存储表格选中的值
            multipleSelection: [],

            // 页码
            page: 1,
            // 页数
            limit: 10,
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            activeiesFunShow: false,
        }
    },
    created() {
        // 获取 红包兑换明细接口数据
        this.loading = true
        this.getredDetailsBtn()

        setTimeout(() => {
            this.activeiesFunShow = this.$store.state.pageFunctionShow
        }, 1000);

    },

    methods: {
        // 获取红包对明细接口数据
        getredDetailsBtn() {
            let params = {
                userId: this.userId, // 用户id
                userPhone: this.userPhone, // 用户手机号
                nickname: this.userName, // 用户名称
                status:
                    this.remitType == 0 ? '' : this.remitType == 1 ? 'ENTER' : 'PAST', // 打款状态 ENTER 已入账 WAIT 待入账 PAST 已过期
                createStartTime: this.conversionTimeA, // 兑换开始时间
                createEndTime: this.conversionTimeB, // 兑换结束时间
                pageSize: this.limit, // 页码
                pageNo: this.page, // 页数
            }

            getredDetails(params).then((res) => {
                console.log('点击获取数据', res)
                if (res.resultStatus == true) {
                    // 表格数据
                    this.tableData = res.resultData.redLogList
                    // 总条数
                    this.totalNum = res.resultData.totalNum
                    this.loading = false
                }
            })
        },

        // 第一区域点击查询
        detailInquire() {
            this.loading = true
            if (this.conversionTime != null || this.conversionTime.length != 0) {
                this.conversionTimeA = this.conversionTime[0]
                this.conversionTimeB = this.conversionTime[1]
            } else {
                this.conversionTimeA = ''
                this.conversionTimeB = ''
            }

            this.$nextTick(() => {
                this.getredDetailsBtn()
            })
        },

        // 第一区域点击重置
        detailReset() {
            this.userId = '' // 用户id
            this.userPhone = '' // 用户手机号
            this.userName = '' // 用户名称
            this.remitType = '' // 奖品类型  打款状态 ENTER 已入账 WAIT 待入账 PAST 已过期
            this.conversionTimeA = '' // 中将开始时间
            this.conversionTimeB = '' // 中将结束时间
            this.conversionTime = []
            this.page = 1
            // 清空重选搜索
            this.getredDetailsBtn()
        },

        // 第二区域 刷新
        refresh() {
            this.loading = true

            this.$nextTick(() => {
                this.getredDetailsBtn()
            })
        },

        // 用户点击导出订单
        export2Excel() {
            if (this.activeiesFunShow == false) {
                return
            }

            this.loading = true

            let redIds = ''

            if (this.multipleSelection.length == 0) {
                redIds = ''
            } else {
                redIds = this.multipleSelection
                    .map((item) => {
                        return item
                    })
                    .join(';')
            }
            let statusType =
                this.remitType == 0
                    ? ''
                    : this.remitType == 1
                        ? 'WAIT'
                        : this.remitType == 2
                            ? 'ENTER'
                            : 'PAST'

            let conversionTimeA =
                this.conversionTimeA == undefined ? '' : this.conversionTimeA
            let conversionTimeB =
                this.conversionTimeB == undefined ? '' : this.conversionTimeB

            /*---------------------*/

            let Url =
                'https://laravel-api-manager.xmw1688.com/v1/manager/red/log?excel=' +
                1 +
                '&ids=' +
                redIds +
                '&userId' +
                this.userId +
                '&userPhone=' +
                this.userPhone +
                '&nickname=' +
                this.userName +
                '&status=' +
                statusType +
                '&createStartTime=' +
                conversionTimeA +
                '&createEndTime=' +
                conversionTimeB +
                '&accessToken=' +
                localStorage.getItem('token')

            console.log('查看导出url', Url)

            //   window.location.href = Url

            this.loading = false
        },

        // 表格区域点击选中 勾选对应的
        handleSelectionChange(val) {
            this.multipleSelection = val
        },

        // 查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            console.log(`每页 ${val} 条`)
            this.getredDetailsBtn()
        },
        // 查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            console.log(`当前页: ${val}`)
            this.getredDetailsBtn()
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.detail {
    .detail-first {
        height: 180px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 30px 24px;
        box-sizing: border-box;

        .detail-first-block {
            display: flex;
            align-items: center;

            .first-block-list {
                margin-right: 24px;

                .first-block-list-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 4px;
                }

                .first-block-list-input {
                    width: 180px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 5px;

                    /deep/ .el-input {
                        height: 32px;
                    }

                    /deep/ .el-input__inner {
                        padding: 0 10px;
                        box-sizing: border-box;
                        height: 32px;
                        background-color: rgba(255, 255, 255, 0);
                    }

                    /deep/ .el-select .el-input.is-focus .el-input__inner {
                        border-color: rgba(217, 217, 217, 1);
                    }
                }

                .first-block-list-picker {
                    width: 385px;

                    /deep/ .el-input__inner {
                        height: 32px;
                    }

                    /deep/ .el-range-editor.el-input__inner {
                        padding: 0;
                        padding: 0 12px;
                        box-sizing: border-box;
                    }

                    /deep/ .el-date-editor--daterange.el-input__inner {
                        width: 100%;
                    }

                    /deep/ .el-date-editor .el-range-separator {
                        width: 26px;
                        padding: 0;
                        height: 32px;
                        line-height: 32px;
                        background-image: url('../../assets/activities/activities-right.png');
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }
            }

            .first-block-list:last-child {
                margin-right: 0;
            }
        }

        .detail-first-button {
            display: flex;
            margin-top: 27px;

            .detail-first-button-left,
            .detail-first-button-right {
                width: 110px;
                height: 36px;
                background: #222222;
                border-radius: 10px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: center;
                line-height: 36px;
                cursor: pointer;
            }

            .detail-first-button-right {
                background: #f4f5f9;
                color: #999999;
                margin-left: 10px;
            }
        }
    }

    .detail-second {
        margin-top: 24px;
        background: #ffffff;
        padding: 0 24px;
        box-sizing: border-box;

        .detail-second-top {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .second-top-left {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #222222;
            }

            .second-top-right {
                display: flex;

                .second-top-right-refresh {
                    width: 70px;
                    height: 36px;
                    border-radius: 10px;
                    border: 1px solid rgba(34, 34, 34, 0.4);
                    text-align: center;
                    line-height: 36px;
                    cursor: pointer;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: bold;
                }

                .second-top-right-derive {
                    display: flex;
                    height: 36px;
                    align-items: center;
                    justify-content: center;
                    width: 110px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    margin-left: 10px;
                    cursor: pointer;

                    .derive-img {
                        width: 12px;
                        height: 12px;
                        margin-right: 5px;
                    }

                    .derive-title {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                    }
                }
            }
        }

        .detail-second-table {
            /deep/ .el-table .el-table__cell {
                padding: 0;
            }

            /deep/ .el-table__header-wrapper {
                height: 46px;
                background: #d8d8d8;
                display: flex;
                align-items: center;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            /deep/ table.el-table__header {
                height: 100%;
            }

            /deep/ .el-table__empty-text {
                line-height: 0;
            }

            .empty-block {
                margin-top: 62px;
                padding-bottom: 40px;

                .empty-block-img {
                    width: 130px;
                    height: 130px;
                    margin: 0 auto;
                }

                .empty-block-text {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 10px;
                    height: 17px;
                    line-height: 17px;
                }
            }
        }

        .detail-second-Pagination {
            height: 88px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            /deep/ .el-pagination .btn-prev {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                margin-right: 8px;
            }

            /deep/ .el-pagination .btn-next {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
            }

            /deep/ .el-pager li {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                line-height: 32px;
                margin-right: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }

            /deep/ .el-pager li.active {
                background: #000000;
                color: #ffffff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 32px;
            }

            /deep/ .el-input__inner {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }
}
</style>
